export const en = {
  taskSent: 'Task sent.',
  removeLink: 'Remove link',
  confirmRemove: 'Really remove?'
};

export type Translations = typeof en;
